module.exports = __webpack_public_path__ + "static/media/Brazil.b459715b.svg";